const UserDefinedFields = () => import("Core/configuration/user_defined_fields/views/UserDefinedFields");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/user_defined_fields",
            name: "settings_user_defined_fields",
            component: UserDefinedFields,
            meta: {
                requiresAuth: true,
                title: "lang.user_defined_fields",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
